// import React from "react";

import React, { useEffect, useState } from "react";
import LegalPage from "../components/LegalPage";


function VpDebug() {
  const [v, setV] = useState({});

  useEffect(() => {
    const tick = () => {
      const html = document.documentElement;
      setV({
        iw: window.innerWidth,
        ih: window.innerHeight,
        dpr: window.devicePixelRatio,
        htmlFS: getComputedStyle(html).fontSize,
        bodyFS: getComputedStyle(document.body).fontSize,
      });
    };

    tick();
    window.addEventListener("resize", tick);
    return () => window.removeEventListener("resize", tick);
  }, []);

  return (
    <div className="fixed bottom-2 left-2 z-[9999] rounded bg-black/80 text-white px-2 py-1 text-[11px] leading-tight">
      {JSON.stringify(v)}
    </div>
  );
}



export default function Terms() {



  return (
    
    <LegalPage title="Terms and Conditions">

      <VpDebug />
  <p>
    These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full. If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website.
  </p>

  <section>
    <h2>License to use website</h2>
    <p>
      Unless otherwise stated, Kepithor Studios owns the intellectual property rights in the website and material on the website. Subject to the license below, all these intellectual property rights are reserved.
    </p>
    <p>
      You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
    </p>
    <p>
      You must not:
    </p>
    <ul>
      <li>Republish material from this website (including republication on another website);</li>
      <li>Sell, rent or sub-license material from the website;</li>
      <li>Show any material from the website in public;</li>
      <li>Reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;</li>
      <li>Redistribute material from this website except for content specifically and expressly made available for redistribution.</li>
    </ul>
  </section>

  <section>
    <h2>Acceptable use</h2>
    <p>
      You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
    </p>
    <p>
      You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of or is linked to any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
    </p>
    <p>
      You must not conduct any systematic or automated data collection activities including without limitation scraping, data mining, data extraction and data harvesting on or in relation to this website without Kepithor Studios' express written consent.
    </p>
    <p>
      It is not acceptable to have multiple accounts. These accounts will be terminated, and IP addresses blocked.
    </p>
  </section>

  <section>
    <h2>Cookies</h2>
    <p>
      This website uses cookies. By using the website you agree to Kepithor Studios' use of cookies. If you do not agree with the use of cookies you cannot use the website.
    </p>
    <p>
      Tracking cookies are used to collect information with regards to IP addresses, referral sources, pageviews and times spent on pages.
    </p>
  </section>

  <section>
    <h2>Referrals</h2>
    <p>
      There is no limit to the number of people you can refer.
    </p>
    <p>
      This website uses cookies to track referrals. Users may or may not block cookies preventing tracking of referrals; as such Kepithor Studios will not be held liable for any failure to register new users as another user's referral.
    </p>
  </section>

  <section>
    <h2>Restricted access</h2>
    <p>
      Access to certain areas of this website is restricted. Kepithor Studios reserves the right to restrict access to areas of this website, or indeed this entire website, at Kepithor Studios' discretion.
    </p>
    <p>
      If Kepithor Studios provides you with a user ID and password to enable you to access restricted areas of this website or other content or services, it is your responsibility to ensure that the user ID and password are kept confidential. Kepithor Studios may disable your user ID and password at Kepithor's sole discretion without notice or explanation.
    </p>
  </section>

  <section>
    <h2>User content</h2>
    <p>
      In these terms and conditions, “your user content” means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to this website, for whatever purpose.
    </p>
    <p>
      You grant to Kepithor Studios a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate and distribute your user content in any existing or future media. You also grant to Kepithor the right to sublicense these rights, and the right to bring an action for infringement of these rights.
    </p>
    <p>
      Your user content must not be illegal or unlawful, must not infringe any third party's legal rights, and must not be capable of giving rise to legal action whether against you or Kepithor Studios or a third party (in each case under any applicable law).
    </p>
    <p>
      You must not submit any user content to the website that is or has ever been the subject of any threatened or actual legal proceedings or other similar complaint.
    </p>
    <p>
      Kepithor Studios reserves the right to edit or remove any material submitted to this website, or stored on Kepithor Studios' servers, or hosted or published upon this website.
    </p>
    <p>
      Notwithstanding Kepithor Studios' rights under these terms and conditions in relation to user content, Kepithor Studios does not undertake to monitor the submission of such content to, or the publication of such content on this website.
    </p>
  </section>

  <section>
    <h2>Content</h2>
    <p>
      Kepithor Studios reserves the right to update the content of the website or its functionality at its sole discretion.
    </p>
    <p>
      Kepithor Studios may at any time include links to other websites on this website. These links are provided for your convenience to provide further information. They do not signify that Kepithor Studios endorses the website(s), nor the content within them. As such Kepithor Studios will not be held responsible for any content of linked websites.
    </p>
    <p>
      Kepithor Studios makes no guarantee that the website or any part of it will always be available, or that access will not be interrupted. Kepithor Studios will have no liability for any user being unable to access any part or all of the website at any time for any reason.
    </p>
    <p>
      Kepithor Studios reserves the right to change, suspend or discontinue any aspect of the website without notice.
    </p>
  </section>

  <section>
    <h2>Linking to the website</h2>
    <p>
      You may link to the website provided you do so in a fair and legal manner that does not harm Kepithor Studios' reputation or take advantage of it. You are permitted to use the links and banners provided on the referrals page.
    </p>
  </section>

  <section>
    <h2>Communications</h2>
    <p>
      By registering with the website you agree to receive communications via email from Kepithor Studios, as and when Kepithor Studios considers written communication necessary.
    </p>
  </section>

  <section>
    <h2>Data Transfers</h2>
    <p>
      Kepithor Studios reserves the right to store data in different countries to which the user data was originally entered. Thus transferring the data to the website’s hosting location.
    </p>
  </section>

  <section>
    <h2>Domain Names</h2>
    <p>
      By registering with this website you agree not to purchase any domain names of similarity such as but not limited to kingdomkarnage.org.
    </p>
  </section>

  <section>
    <h2>Reliance</h2>
    <p>
      Kepithor Studios makes no guarantees that the content on this website is accurate, complete, or up to date.
    </p>
  </section>

  <section>
    <h2>No warranties</h2>
    <p>
      This website is provided “as is” without any representations or warranties, express or implied. Kepithor Studios makes no representations or warranties in relation to this website or the information and materials provided on this website.
    </p>
    <p>
      Without prejudice to the generality of the foregoing paragraph, Kepithor Studios does not warrant that: this website will be constantly available, or available at all; or the information on this website is complete, true, accurate or non-misleading.
    </p>
    <p>
      Nothing on this website constitutes, or is meant to constitute, advice of any kind. If you require advice in relation to any [legal, financial or medical] matter you should consult an appropriate professional.
    </p>
  </section>

  <section>
    <h2>Limitations of liability</h2>
    <p>
      Kepithor Studios will not be liable to you (whether under the law of contract, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website: to the extent that the website is provided free-of-charge, for any direct loss; for any indirect, special or consequential loss; or
      for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.
    </p>
    <p>
      Kepithor Studios cannot be held accountable for any failure for email reminders not being sent and as such any user's failure to check the website and claim any winning draws.
    </p>
    <p>
      These limitations of liability apply even if Kepithor Studios has been expressly advised of the potential loss.
    </p>
    <p>
      Kepithor Studios will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or other harmful material that may infect your computer equipment, programs, data or other proprietary material due to your use of this website, your downloading of any content from it to any website linked to it.
    </p>
    <p>
      Kepithor Studios does not guarantee that the website will be secure or free from any malicious software. You are solely responsible for the protection of your equipment, software and data.
    </p>
  </section>

  <section>
    <h2>Exceptions</h2>
    <p>
      Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit Kepithor Studios' liability in respect of any: death or personal injury caused by Kepithor Studios' negligence; fraud or fraudulent misrepresentation on the part of Kepithor; or matter which it would be illegal or unlawful for Kepithor Studios to exclude or limit, or to attempt or purport to exclude or limit, its liability.
    </p>
  </section>

  <section>
    <h2>Reasonableness</h2>
    <p>
      By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.
    </p>
    <p>
      If you do not think they are reasonable, you must not use this website.
    </p>
  </section>

  <section>
    <h2>Other parties</h2>
    <p>
      You accept that, as a limited liability entity, Kepithor Studios has an interest in limiting the personal liability of its officers or employees. You agree that you will not bring any claim personally against Kepithor Studios' officers or employees in respect of any losses you suffer in connection with the website.
    </p>
    <p>
      Without prejudice to the foregoing paragraph, you agree that the limitations of warranties and liability set out in this website disclaimer will protect Kepithor Studios' officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as Kepithor Studios.
    </p>
  </section>

  <section>
    <h2>Unenforceable provisions</h2>
    <p>
      If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.
    </p>
  </section>

  <section>
    <h2>Indemnity</h2>
    <p>
      You hereby indemnify Kepithor Studios and undertake to keep Kepithor Studios indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by Kepithor Studios to a third party in settlement of a claim or dispute on the advice of Kepithor Studios' legal advisers) incurred or suffered by Kepithor Studios arising out of any breach by you of any provision of these terms and conditions, or arising out of any claim that you have breached any provision of these terms and conditions.
    </p>
  </section>

  <section>
    <h2>Breaches of these Terms and Conditions</h2>
    <p>
      Without prejudice to Kepithor Studios' other rights under these terms and conditions, if you breach these terms and conditions in any way, Kepithor Studios may take such action as Kepithor Studios deems appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.
    </p>
  </section>

  <section>
    <h2>Variation</h2>
    <p>
      Kepithor Studios may revise these terms and conditions from time-to-time. Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website. Please check this page regularly to ensure you are familiar with the current version.
    </p>
  </section>

  <section>
    <h2>Assignment</h2>
    <p>
      Kepithor Studios may transfer, sub-contract or otherwise deal with Kepithor Studios' rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.
    </p>
    <p>
      You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.
    </p>
  </section>

  <section>
    <h2>Severability</h2>
    <p>
      If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect. If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.
    </p>
  </section>

  <section>
    <h2>Entire Agreement</h2>
    <p>
      These terms and conditions, together with privacy policy, and end user license agreement, constitute the entire agreement between you and Kepithor Studios in relation to your use of this website and game applications, and supersede all previous agreements in respect of your use of this website.
    </p>
  </section>

  <section>
    <h2>Law and Jurisdiction</h2>
    <p>
      These terms and conditions will be governed by and construed in accordance with United Kingdom Law, and any disputes relating to these terms and conditions will be subject to the non-exclusive jurisdiction of the courts of The United Kingdom.
    </p>
  </section>

  <section>
    <h2>Contacting Us</h2>
    <p>
      If there are any questions regarding this privacy policy you may contact us by emailing team(at)kepithorstudios.com.
    </p>
  </section>
  
    </LegalPage>
  );
}